import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { th } from 'date-fns/locale';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-add-time',
  templateUrl: './add-time.component.html',
  styleUrls: ['./add-time.component.scss']
})
export class AddTimeComponent implements OnInit {

  constructor(private popoverRef: PopoverRef<any>, private examSchService: ExamScheduleService, private examService: ExamService, private snackBar: SnackbarService,) { }
  addedMinutes: number = 0;
  ngOnInit(): void {
  }

  close(){
    this.popoverRef.close();
  }

  async yesClicked(){
     let data = {
        Ids: this.examSchService.selectedIds.map(x => parseInt(x)),
        Minutes: this.addedMinutes, 
        SelectAll: this.examSchService.selectAll,
        ExaminationID: this.examService.selectedExamIds[0],
      }
    const res = await this.examSchService.addTime(data) as any[];
      if(res !== null && res.length > 0){
        res.forEach(e =>{
          this.snackBar.error(e);
        })        
      }
      else{
        this.snackBar.success('Time Added Successfully!', 5000);
      }
      this.examSchService.reloadGrid.next(true);
    this.close();
  }

  noClicked(){
    this.close();
  }

  setAddedMinutes(event){
    this.addedMinutes = parseInt(event.target.value);
  }

}
